/**
 * Icones de navigation, dessinees ici en SVG.
 *
 * Aucune police d'icones externe, aucune image : tout est inline. Deux
 * raisons, et la seconde compte autant que la premiere :
 *
 *   - une police d'icones est une requete vers un tiers, que la politique de
 *     securite du serveur (CSP, a la mise en ligne) bloquera ;
 *   - un trait dessine ici suit la couleur du texte (`currentColor`), donc la
 *     charte du client, sans qu'on ait a produire un jeu d'icones par couleur.
 *
 * Traits volontairement simples : a 18 pixels, le detail ne se voit pas et
 * alourdit le rendu.
 */

function Svg({ children, taille = 18 }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconeTableauDeBord(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </Svg>
  );
}

/** Camion : c'est le metier, autant que l'icone le dise. */
export function IconeVehicules(props) {
  return (
    <Svg {...props}>
      <path d="M2 17V7a1 1 0 0 1 1-1h10v11" />
      <path d="M13 9h4l3 3.5V17" />
      <circle cx="7" cy="17.5" r="1.8" />
      <circle cx="17" cy="17.5" r="1.8" />
      <path d="M8.8 17.5h6.4" />
    </Svg>
  );
}

export function IconeUtilisateurs(props) {
  return (
    <Svg {...props}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16 11.2A3 3 0 0 0 16 5.3" />
      <path d="M17.5 20a5.5 5.5 0 0 0-2.2-4.4" />
    </Svg>
  );
}

/** Immeuble : les clients de l'editeur sont des entreprises. */
export function IconeClients(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="4" width="9" height="17" rx="1" />
      <rect x="12" y="9" width="9" height="12" rx="1" />
      <path d="M6 8h3M6 12h3M6 16h3M15 13h3M15 17h3" />
    </Svg>
  );
}

/** Silhouette : mon propre compte. */
export function IconeMonCompte(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="8" r="3.4" />
      <path d="M5 20a7 7 0 0 1 14 0" />
    </Svg>
  );
}

/** Oeil : afficher le mot de passe en clair. */
export function IconeOeil(props) {
  return (
    <Svg {...props}>
      <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </Svg>
  );
}

/** Oeil barre : masquer le mot de passe. */
export function IconeOeilBarre(props) {
  return (
    <Svg {...props}>
      <path d="M2 12s3.6-6.5 10-6.5c1.7 0 3.2.5 4.5 1.1" />
      <path d="M20.6 8.6C21.5 10 22 12 22 12s-3.6 6.5-10 6.5c-1.9 0-3.5-.6-4.9-1.3" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
      <path d="M3 3l18 18" />
    </Svg>
  );
}

/** Billet : le financement, ce que le camion coute encore. */
export function IconeFinancement(props) {
  return (
    <Svg {...props}>
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M6 10v4M18 10v4" />
    </Svg>
  );
}

/** Cle : la location, un camion confie a un tiers. */
export function IconeLocation(props) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="12" r="4" />
      <path d="M12 12h9M18 12v3M21 12v2" />
    </Svg>
  );
}

/** Carton : le stock de pieces de l'atelier. */
export function IconeStock(props) {
  return (
    <Svg {...props}>
      <path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z" />
      <path d="M3 7.5 12 12l9-4.5" />
      <path d="M12 12v9" />
    </Svg>
  );
}

/** Presse-papier coche : une inspection est une liste de points a verifier. */
export function IconeInspections(props) {
  return (
    <Svg {...props}>
      <path d="M9 4h6v3H9z" />
      <path d="M15 5.5h2A1.5 1.5 0 0 1 18.5 7v12A1.5 1.5 0 0 1 17 20.5H7A1.5 1.5 0 0 1 5.5 19V7A1.5 1.5 0 0 1 7 5.5h2" />
      <path d="m9 13 2 2 4-4" />
    </Svg>
  );
}

/** Cloche : les reglages de cet ecran ne parlent que d'alertes. */
export function IconeAlertes(props) {
  return (
    <Svg {...props}>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 0 1-3.4 0" />
    </Svg>
  );
}

export function IconeDeconnexion(props) {
  return (
    <Svg {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
    </Svg>
  );
}

export function IconeMenu(props) {
  return (
    <Svg {...props}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </Svg>
  );
}

export function IconeFermer(props) {
  return (
    <Svg {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </Svg>
  );
}

/**
 * Enveloppe : ecrire a l'editeur depuis le bas du menu.
 *
 * Le bouton portait un emoji (« ✉️ »). Un emoji n'est pas un trait : son
 * dessin change d'un systeme a l'autre, il garde ses propres couleurs et
 * ignore donc `currentColor` -- c'est-a-dire la charte du client. Depuis que
 * l'icone est seule, sans libelle a cote, elle porte tout le sens du bouton :
 * autant qu'elle soit dessinee ici comme les autres.
 */
export function IconeEnveloppe(props) {
  return (
    <Svg {...props}>
      <rect x="2.5" y="5" width="19" height="14" rx="2" />
      <path d="m3.2 6.6 8.8 6 8.8-6" />
    </Svg>
  );
}
